(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["adv-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('adv-review-carousel')) {
    customElements.define('adv-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        const step = () => {
          const card = this.track.querySelector('.adv-rev__card');
          return card ? card.offsetWidth + 22 : 320;
        };
        this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));

        const paintArrows = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max;
        };
        this.track.addEventListener('scroll', paintArrows, { passive: true });
        window.addEventListener('resize', paintArrows);
        paintArrows();

        let down = false, startX = 0, startL = 0, moved = false;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;
          down = true; moved = false; startX = e.clientX; startL = this.track.scrollLeft;
          this.track.classList.add('is-drag');
        });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          this.track.scrollLeft = startL - dx;
        });
        window.addEventListener('pointerup', () => { down = false; this.track.classList.remove('is-drag'); });
        this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.animate === 'true' && !reduce && ('IntersectionObserver' in window)) {
          this.classList.add('is-armed');
          var host = this;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { host.classList.add('is-in'); io.disconnect(); } });
          }, { threshold: 0.25 });
          io.observe(this);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["adv-testimonials"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('adv-testimonials')) {
    customElements.define('adv-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.setupSound();
        this.setupDrag();
        this.setupArrows();
        this.setupAutoplay(this.dataset.autoplay === 'true');
      }

      setupSound() {
        this.cards.forEach((card) => {
          const video = card.querySelector('[data-video]');
          const sound = card.querySelector('[data-sound]');
          sound.addEventListener('click', (e) => {
            e.stopPropagation();
            const turnOn = video.muted;
            this.cards.forEach((c) => {
              const v = c.querySelector('[data-video]');
              v.muted = true; c.classList.remove('is-unmuted');
              c.querySelector('[data-sound]').setAttribute('aria-label', 'Slå lyd til');
            });
            if (turnOn) { video.muted = false; video.play().catch(() => {}); card.classList.add('is-unmuted'); sound.setAttribute('aria-label', 'Slå lyd fra'); }
          });
        });
      }

      setupDrag() {
        const t = this.track;
        let down = false, startX = 0, startScroll = 0, moved = false;
        t.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return;
          down = true; moved = false; startX = e.pageX; startScroll = t.scrollLeft;
          t.classList.add('is-dragging');
        });
        t.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.pageX - startX;
          if (Math.abs(dx) > 4) moved = true;
          t.scrollLeft = startScroll - dx;
        });
        const end = () => { if (down) { down = false; t.classList.remove('is-dragging'); this.updateArrows(); } };
        t.addEventListener('pointerup', end);
        t.addEventListener('pointercancel', end);
        t.addEventListener('pointerleave', end);
        t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        t.addEventListener('dragstart', (e) => e.preventDefault());
      }

      page() { return Math.max(this.track.clientWidth * 0.85, 160); }

      setupArrows() {
        if (this.prev) this.prev.addEventListener('click', () => this.track.scrollBy({ left: -this.page(), behavior: 'smooth' }));
        if (this.next) this.next.addEventListener('click', () => this.track.scrollBy({ left: this.page(), behavior: 'smooth' }));
        this.track.addEventListener('scroll', () => this.updateArrows());
        window.addEventListener('resize', () => this.updateArrows());
        this.updateArrows();
        requestAnimationFrame(() => this.updateArrows());
      }

      updateArrows() {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 4;
        this.track.classList.toggle('is-centered', !overflow);
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.classList.toggle('is-hidden', !overflow || this.track.scrollLeft <= 2);
        this.next.classList.toggle('is-hidden', !overflow || this.track.scrollLeft >= max);
      }

      setupAutoplay(on) {
        if (!on || !('IntersectionObserver' in window)) return;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            const v = en.target.querySelector('[data-video]');
            if (!v) return;
            if (en.isIntersecting) { v.play().catch(() => {}); }
            else { v.pause(); if (!v.muted) { v.muted = true; en.target.classList.remove('is-unmuted'); } }
          });
        }, { threshold: 0.4 });
        this.cards.forEach((c) => io.observe(c));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sadasda"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-selector')) {
    // Number format follows the storefront language: da -> 1.959 kr, sv -> 1 959 kr
    let advNumLocale = 'da-DK';
    const kr = (n) => Math.round(n).toLocaleString(advNumLocale) + ' kr';
    const easeInOut = (k) => (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);

    customElements.define('bundle-selector', class extends HTMLElement {
      connectedCallback() {
        const loc = (this.dataset.locale || 'da').toLowerCase();
        advNumLocale = loc.indexOf('sv') === 0 ? 'sv-SE' : 'da-DK';
        // Translatable texts (block settings -> Translate & Adapt)
        this.t = {
          save: this.dataset.tSave || 'Spar',
          saved: this.dataset.tSaved || 'Du sparer',
          unit: this.dataset.tUnit || 'stk.'
        };

        this.unit = (parseFloat(this.dataset.unit) || 0) / 100;
        this.unitCompare = (parseFloat(this.dataset.unitCompare) || 0) / 100 || this.unit;
        this.variantId = this.dataset.variantId;
        this.afterAdd = this.dataset.afterAdd || 'checkout';
        this.flexQty = {};

        this.tiers = Array.from(this.querySelectorAll('.adv-bundle__tier'));
        this.totalEl = this.querySelector('[data-total]');
        this.totalCompareEl = this.querySelector('[data-total-compare]');
        this.saveEl = this.querySelector('[data-save]');
        this.cta = this.querySelector('.adv-bundle__cta');

        this.tiers.forEach((t) => {
          if (t.dataset.flex === 'true') this.flexQty[t.dataset.index] = parseInt(t.dataset.qty, 10) || 1;
          this.paintTier(t);
          t.querySelector('.adv-bundle__radio').addEventListener('change', () => this.select(t));
          const minus = t.querySelector('[data-step="-"]');
          const plus = t.querySelector('[data-step="+"]');
          if (minus && plus) {
            minus.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.step(t, -1); });
            plus.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.step(t, 1); });
          }
        });

        this.setupVariants();
        this.setupAddon();
        this.cta.addEventListener('click', () => this.addToCart());

        const checked = this.tiers.find((t) => t.querySelector('.adv-bundle__radio').checked) || this.tiers[0];
        if (checked) this.select(checked);

        if (this.dataset.live === 'true') this.startLive(parseInt(this.dataset.liveCount, 10) || 40);

        // Back/forward cache: when returning from checkout/cart the browser may
        // restore a frozen snapshot (stuck loading button, stale cart count).
        window.addEventListener('pageshow', (e) => {
          this.cta.classList.remove('is-loading');
          if (sessionStorage.getItem('advBundleNav')) {
            sessionStorage.removeItem('advBundleNav');
            if (e.persisted) window.location.reload();
          }
        });

        requestAnimationFrame(() => this.classList.add('is-ready'));
      }

      qtyOf(t) { return t.dataset.flex === 'true' ? this.flexQty[t.dataset.index] : parseInt(t.dataset.qty, 10) || 1; }

      calc(t, qty) {
        const d = parseFloat(t.dataset.discount) || 0;
        const price = this.unit * (1 - d / 100) * qty;
        const compare = this.unitCompare * qty;
        return { p: Math.round(price), c: Math.round(compare), s: Math.round(compare - price), pct: compare > 0 ? Math.round(((compare - price) / compare) * 100) : 0 };
      }

      paintTier(t) {
        const r = this.calc(t, this.qtyOf(t));
        const pill = t.querySelector('[data-pill]'); const price = t.querySelector('[data-price-out]'); const comp = t.querySelector('[data-comp]');
        const q = t.querySelector('[data-q]'); const lblq = t.querySelector('[data-lblq]');
        if (pill) pill.textContent = r.s > 0 ? this.t.save + ' ' + r.pct + '%' : '';
        if (price) price.textContent = kr(r.p);
        if (comp) comp.textContent = r.s > 0 ? kr(r.c) : '';
        if (q) q.textContent = this.qtyOf(t);
        if (lblq) lblq.textContent = this.qtyOf(t);
      }

      step(t, dir) {
        const min = parseInt(t.dataset.qty, 10) || 1;
        let v = this.flexQty[t.dataset.index] + dir;
        if (v < min) v = min;
        this.flexQty[t.dataset.index] = v;
        const minus = t.querySelector('[data-step="-"]');
        if (minus) minus.disabled = v <= min;
        this.paintTier(t);
        this.select(t);
      }

      setupVariants() {
        this.varsEl = this.querySelector('[data-vars]');
        if (!this.varsEl) return;
        try { this.pvars = JSON.parse(this.varsEl.querySelector('[data-variants]').textContent); }
        catch (e) { this.pvars = []; }
        this.pvars = this.pvars.filter((v) => v.available !== false);
        if (this.pvars.length < 2) { this.varsEl.style.display = 'none'; this.pvars = null; return; }
        this.varChoice = [];
        this.vrowsEl = this.varsEl.querySelector('[data-vrows]');
      }

      syncVariants() {
        if (!this.pvars) return;
        const n = this.qtyOf(this.activeTier) || 1;
        while (this.varChoice.length < n) this.varChoice.push(0);
        this.varChoice.length = n;
        this.renderVRows();
      }

      renderVRows() {
        if (!this.vrowsEl) return;
        this.vrowsEl.innerHTML = '';
        this.varChoice.forEach((choice, idx) => {
          const row = document.createElement('div');
          row.className = 'adv-bundle__row';
          let html = '<span class="adv-bundle__rn">#' + (idx + 1) + '</span><span class="adv-bundle__sws">';
          this.pvars.forEach((c, ci) => {
            const img = c.image ? '<img src="' + c.image + '" alt="' + c.title + '">' : '';
            html += '<button type="button" class="adv-bundle__sw' + (choice === ci ? ' is-active' : '') + '" data-ci="' + ci + '" aria-label="' + c.title + '">' + img + '</button>';
          });
          html += '</span><span class="adv-bundle__rname">' + (this.pvars[choice] ? this.pvars[choice].title : '') + '</span>';
          row.innerHTML = html;
          this.vrowsEl.appendChild(row);
          row.querySelectorAll('.adv-bundle__sw').forEach((sw) => {
            sw.addEventListener('click', () => { this.varChoice[idx] = parseInt(sw.dataset.ci, 10); this.renderVRows(); });
          });
        });
      }

      setupAddon() {
        this.addonEl = this.querySelector('[data-addon]');
        if (!this.addonEl) return;
        this.addonOn = false;
        this.coverMax = parseInt(this.addonEl.dataset.max, 10) || 8;
        try { this.covers = JSON.parse(this.addonEl.querySelector('[data-covers]').textContent); }
        catch (e) { this.covers = []; }
        this.covers = this.covers.filter((c) => c.available !== false);
        this.coverChoice = [];
        this.rowsEl = this.addonEl.querySelector('[data-rows]');
        this.countEl = this.addonEl.querySelector('[data-ccount]');

        const base = this.covers[0];
        if (base) {
          const now = this.addonEl.querySelector('[data-cover-now]');
          const was = this.addonEl.querySelector('[data-cover-was]');
          if (now) now.textContent = '+ ' + kr(base.price / 100) + '/' + this.t.unit;
          if (was && base.compare > base.price) was.textContent = kr(base.compare / 100) + '/' + this.t.unit;
        }

        this.addonEl.querySelector('[data-atop]').addEventListener('click', () => this.toggleAddon());
        this.addonEl.querySelector('[data-atop]').addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleAddon(); } });
        this.addonEl.querySelector('[data-cs="-"]').addEventListener('click', () => this.coverStep(-1));
        this.addonEl.querySelector('[data-cs="+"]').addEventListener('click', () => this.coverStep(1));
      }

      toggleAddon() {
        this.addonOn = !this.addonOn;
        this.addonEl.classList.toggle('is-on', this.addonOn);
        this.addonEl.querySelector('[data-atop]').setAttribute('aria-pressed', this.addonOn);
        const hint = this.addonEl.querySelector('[data-ahint]');
        if (hint) hint.textContent = this.addonOn ? (this.addonEl.dataset.hintOn || '') : (this.addonEl.dataset.hintOff || '');
        if (this.addonOn) {
          const n = this.qtyOf(this.activeTier) || 1;
          this.coverChoice = [];
          for (let i = 0; i < n; i++) this.coverChoice.push(0);
          this.renderRows();
        }
        this.update();
      }

      coverStep(dir) {
        let n = this.coverChoice.length + dir;
        if (n < 1) n = 1;
        if (n > this.coverMax) n = this.coverMax;
        if (n > this.coverChoice.length) this.coverChoice.push(0);
        else this.coverChoice.length = n;
        this.renderRows();
        this.update();
      }

      renderRows() {
        if (!this.rowsEl) return;
        this.rowsEl.innerHTML = '';
        this.coverChoice.forEach((choice, idx) => {
          const row = document.createElement('div');
          row.className = 'adv-bundle__row';
          let html = '<span class="adv-bundle__rn">#' + (idx + 1) + '</span><span class="adv-bundle__sws">';
          this.covers.forEach((c, ci) => {
            const img = c.image ? '<img src="' + c.image + '" alt="' + c.title + '">' : '';
            html += '<button type="button" class="adv-bundle__sw' + (choice === ci ? ' is-active' : '') + '" data-ci="' + ci + '" aria-label="' + c.title + '">' + img + '</button>';
          });
          html += '</span><span class="adv-bundle__rname">' + (this.covers[choice] ? this.covers[choice].title : '') + '</span>';
          row.innerHTML = html;
          this.rowsEl.appendChild(row);
          row.querySelectorAll('.adv-bundle__sw').forEach((sw) => {
            sw.addEventListener('click', () => { this.coverChoice[idx] = parseInt(sw.dataset.ci, 10); this.renderRows(); this.update(); });
          });
        });
        if (this.countEl) this.countEl.textContent = this.coverChoice.length;
        const minus = this.addonEl.querySelector('[data-cs="-"]');
        if (minus) minus.disabled = this.coverChoice.length <= 1;
      }

      coverTotals() {
        let p = 0; let c = 0;
        if (this.addonOn) this.coverChoice.forEach((ci) => { const v = this.covers[ci]; if (v) { p += v.price / 100; c += (v.compare > v.price ? v.compare : v.price) / 100; } });
        return { p: p, c: c };
      }

      animateNum(el, to) {
        const from = el._v !== undefined ? el._v : to;
        el._v = to;
        const start = performance.now(); const dur = 700;
        const tick = (now) => { const k = Math.min(1, (now - start) / dur); el.textContent = kr(from + (to - from) * easeInOut(k)); if (k < 1) requestAnimationFrame(tick); };
        requestAnimationFrame(tick);
      }

      update() {
        const t = this.activeTier; if (!t) return;
        const r = this.calc(t, this.qtyOf(t));
        const ct = this.coverTotals();
        const price = r.p + ct.p;
        const comp = r.c + ct.c;
        const s = comp - price;
        if (this.totalCompareEl) this.totalCompareEl.textContent = s > 0 ? kr(comp) : '';
        if (this.totalEl) this.animateNum(this.totalEl, price);
        if (this.saveEl) this.saveEl.textContent = s > 0 ? this.t.saved + ' ' + kr(s) : '';
        this.currentQty = this.qtyOf(t);
      }

      select(t) {
        this.tiers.forEach((x) => x.classList.remove('is-selected'));
        t.classList.add('is-selected');
        const radio = t.querySelector('.adv-bundle__radio'); if (radio) radio.checked = true;
        this.activeTier = t;
        this.syncVariants();
        if (this.addonOn) {
          const n = this.qtyOf(t) || 1;
          this.coverChoice = [];
          for (let i = 0; i < n; i++) this.coverChoice.push(0);
          this.renderRows();
        }
        this.update();
      }

      startLive(base) {
        const el = this.querySelector('[data-live-n]'); if (!el) return;
        let v = base;
        setInterval(() => { v = Math.max(base - 9, Math.min(base + 12, v + (Math.floor(Math.random() * 4) - 1))); el.textContent = v; }, 3800);
      }

      async addToCart() {
        if (!this.variantId) return;
        const q = this.currentQty || this.qtyOf(this.activeTier) || 1;
        const items = [];
        if (this.pvars && this.varChoice && this.varChoice.length) {
          const vcounts = {};
          this.varChoice.forEach((ci) => { const v = this.pvars[ci]; if (v) vcounts[v.id] = (vcounts[v.id] || 0) + 1; });
          Object.keys(vcounts).forEach((id) => items.push({ id: Number(id), quantity: vcounts[id] }));
        } else {
          items.push({ id: Number(this.variantId), quantity: q });
        }
        if (this.addonOn) {
          const counts = {};
          this.coverChoice.forEach((ci) => { const v = this.covers[ci]; if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
          Object.keys(counts).forEach((id) => items.push({ id: Number(id), quantity: counts[id] }));
        }
        this.cta.classList.add('is-loading');
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!res.ok) throw new Error('add failed');
          try { sessionStorage.setItem('advBundleNav', '1'); } catch (e) {}
          window.location.href = this.afterAdd === 'checkout' ? '/checkout' : '/cart';
        } catch (e) {
          this.cta.classList.remove('is-loading');
          try { sessionStorage.setItem('advBundleNav', '1'); } catch (err) {}
          window.location.href = '/cart';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trust"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('trustpilot-box')) {
    customElements.define('trustpilot-box', class extends HTMLElement {
      connectedCallback() {
        const el = this.querySelector('.trustpilot-widget');
        if (!el) return;
        const SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        const init = () => { if (window.Trustpilot && el) window.Trustpilot.loadFromElement(el, true); };
        if (window.Trustpilot) { init(); return; }
        const existing = document.querySelector('script[src*="tp.widget.bootstrap"]');
        if (!existing) {
          const s = document.createElement('script');
          s.async = true; s.src = SRC; s.onload = init;
          document.head.appendChild(s);
        } else {
          let tries = 0;
          const timer = setInterval(() => { tries++; if (window.Trustpilot) { clearInterval(timer); init(); } else if (tries > 60) { clearInterval(timer); } }, 100);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
